import React from 'react';

import EditableTable from './EditableTable';
import { ControlPageBlock, TextAreaField } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

import 'react-datasheet/lib/react-datasheet.css';

export default class TableHtmlEditScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                loading: true,
            },
        };

        this.handleData = this.handleData.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);

        this.saveHtml = this.saveHtml.bind(this);

        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.id) {
            this.state.API_ENDPOINT = `tablehtml/${props.match.params.id}/`;
        } else {
            this.state.API_ENDPOINT = 'tablehtml/';
            this.EDITABLE_EMAIL = true;
        }
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false,
                data: {
                    html: '',
                    json: [
                        [{ value: '' }, { value: '' }],
                        [{ value: '' }, { value: '' }],
                    ],
                },
            });
        }
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        const save_type = event.currentTarget.id;

        let request_method = 'PUT';

        if (!this.props.match.params.id) {
            request_method = 'POST';
        }

        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.id) {
            callback = this.goToNewPage;
        }

        Fetcher(
            this.state.API_ENDPOINT,
            request_method,
            callback,
            { html: this.state.data.html, json: this.state.data.grid || this.state.data.json },
        );
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `tablehtml/${newData.id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/table/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/table/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    saveHtml(grid, html) {
        const { data } = this.state;
        this.setState({ data: { ...data, html, grid } });
    }

    render() {
        if (this.state.data.loading) {
            return '';
        }

        const { data } = this.state;

        const grid = typeof data.json === 'string' ? JSON.parse(data.json.replaceAll('None', 'null')) : data.json;

        return (
            <div>
                <p className="table-editor__label">
                    Таблица
                    <span>*</span>
                </p>
                <EditableTable
                    grid={grid}
                    onChange={this.saveHtml}
                />
                <TextAreaField
                    label="HTML"
                    name="html"
                    onChange={this.handleChange}
                    value={data.html}
                    required
                />
                <div className="container-fluid">
                    <ControlPageBlock
                        name={data.id}
                        onSave={this.sendData}
                        onApply={this.sendData}
                        onCancel={this.goToPreviousPage}
                        onRemove={this.removeData}
                    />
                </div>
            </div>
        );
    }
}
